export const API_ACCESS_TOKEN_EXPIRED = 'TokenExpiredError'
export const API_HEADER_REFRESH_TOKEN = 'refresh-auth-token'
